const usingKeyboard = event => {
    if (event.key !== 'Tab') return;
    document.documentElement.classList.add('is-using-keyboard');
    document.removeEventListener('keydown', usingKeyboard);
    document.addEventListener('mousedown', usingMouse);
}

const usingMouse = () => {
    document.documentElement.classList.remove('is-using-keyboard');
    document.removeEventListener('mousedown', usingMouse);
    document.addEventListener('keydown', usingKeyboard);
}

document.addEventListener('keydown', usingKeyboard);